import { LOAD_ALL_LEAD, LOAD_SINGLE_LEAD } from "./LeadList.saga";

export const loadAllLead = (payload) => ({
  type: LOAD_ALL_LEAD.LOADING,
  payload,
});

export const loadSingleLead = (payload) => ({
  type: LOAD_SINGLE_LEAD.LOADING,
  payload,
});
